// extracted by mini-css-extract-plugin
export default {"row":"ChartTable_row__viodN","up":"ChartTable_up__lUJE0","down":"ChartTable_down__wrLJ3","edit":"ChartTable_edit__r--qu"};